import { useStore } from "react-redux";
import { useEffect, useState } from "react";
import { COMPONENT_COMPARE_V2 } from "../../../shared-logic/server/components";
import { type CompareV2ActionsType, type CompareV2StateType, compareV2Reducers } from "../redux/store";
import newCarCompareLogic from "../redux/logic/NewCarCompareLogic";
import { useCommonSelector } from "../../../common-deprecated/redux/commonStore";
import { executeFrontendDataFetch } from "../../../common-deprecated/hooks/useDataFetcher";
import type { GetFetchesFnType } from "../../../common-deprecated/utils/registryTypes";
import { compareV2FetchDispatcher, getCompareV2ComponentFetches } from "../datafetch/fetchUtils";
import { compareSetNcCompareContext } from "../redux/actions/NewCarCompareActions";
import type { NcCompareContext } from "../../../common-deprecated/types/NewCarCompareTypes";
import {
    type NewCarCompareExternalDataActionsType,
    compareSetFinanceProduct,
} from "../../../common-deprecated/features/compare/redux/actions/NewCarCompareExternalDataActions";

const useIntegratedCompare = (ncCompareContext: NcCompareContext, financeProduct?: string): { fetching: boolean } => {
    const store = useStore<CompareV2StateType, CompareV2ActionsType | NewCarCompareExternalDataActionsType>();
    const commonSettings = useCommonSelector((state) => state.commonSettings);

    const [fetching, setFetching] = useState<boolean>(true);

    useEffect(() => {
        store.addReducers(compareV2Reducers);

        // Put the ncCompareContext & financeProduct in redux before datafetch
        store.dispatch(compareSetNcCompareContext(ncCompareContext));
        if (financeProduct) store.dispatch(compareSetFinanceProduct(financeProduct));

        const fetchData = async (): Promise<void> => {
            await executeFrontendDataFetch(
                store,
                getCompareV2ComponentFetches as unknown as GetFetchesFnType,
                compareV2FetchDispatcher,
                commonSettings,
                COMPONENT_COMPARE_V2,
                ["brand", "envVarsOverride"],
            );

            setFetching(false);

            store.logicMiddleware?.mergeNewLogic(newCarCompareLogic);
        };

        fetchData();
    }, []);

    return { fetching };
};

export default useIntegratedCompare;
